import { College } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export const collegeApi = createApi({
  reducerPath: 'collegeApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getCollegeById: build.query<College, string>({
      query: (id) => `colleges/${id}`,
      keepUnusedDataFor: 60 * 60 * 24,
    }),
  }),
});

export const {
  useGetCollegeByIdQuery,
  usePrefetch: usePrefetchCollege,
  util: { resetApiState },
} = collegeApi;
